import { connect } from 'react-redux';

import { composeLocationClear } from '../../../actions/compose';
import ComposeLocationBanner from '../components/compose_location_banner';

const mapStateToProps = state => ({
  location: state.getIn(['compose', 'location']),
  locationLoading: state.getIn(['compose', 'location_loading']),
});

const mapDispatchToProps = dispatch => ({
  onClear () {
    dispatch(composeLocationClear());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ComposeLocationBanner);
